/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PushSubscriptionResponse interface.
 */
export function instanceOfPushSubscriptionResponse(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('endpoint' in value) || value['endpoint'] === undefined)
        return false;
    return true;
}
export function PushSubscriptionResponseFromJSON(json) {
    return PushSubscriptionResponseFromJSONTyped(json, false);
}
export function PushSubscriptionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'endpoint': json['endpoint'],
    };
}
export function PushSubscriptionResponseToJSON(json) {
    return PushSubscriptionResponseToJSONTyped(json, false);
}
export function PushSubscriptionResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'endpoint': value['endpoint'],
    };
}
